export default {
  id: '',
  idUUID: '',
  email: '',
  name: '',
  authorizationLevel: '',
  authorizations: [],
  externalId: '',
  organizationId: '',
  isAuthenticated: false,
  viewData: {},
  notificationsCount: null,
  notifications: [],
  securitizeIdNotificationsCount: null,
  securitizeIdNotifications: [],
  registerToken: '',
  twoFaUri: '',
};
